import { render } from "./ConsumerInfo.vue?vue&type=template&id=664d8385"
import script from "./ConsumerInfo.vue?vue&type=script&lang=js"
export * from "./ConsumerInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__